export class ImageUtils {
    static getImageType(value: string) {
        if (value.startsWith('<svg')) {
            return 'svg'
        }
        try {
            atob(value);

            return 'base64'
        } catch {}

        return 'unknow'
    }

    private static encodeSvgToImg(value: string) {
        const blob = new Blob([value], { type: 'image/svg+xml' });

        return URL.createObjectURL(blob);
    }
    private static encodeBase64ToString(value: string) {
        return `data:image/png;base64,${value}`;
    }

    static convertValueToImg(value: string) {
        const type = this.getImageType(value);

        if (type === 'svg') return this.encodeSvgToImg(value);
        else if (type === 'base64') return this.encodeBase64ToString(value);

        return '';
    }
}
